import React from "react";
import { formatDispatchEvent, severityClass } from "../../lib/eventFormatter";

export default function DispatchFeed({ events }) {
  return (
    <div className="bg-zinc-900 border border-zinc-800 rounded-xl p-4">
      <h2 className="text-lg font-semibold text-white mb-4">
        Dispatch Feed
      </h2>

      <div className="space-y-3 max-h-[700px] overflow-auto">
        {events.length === 0 && (
          <div className="text-zinc-500 text-sm border border-zinc-800 rounded-lg p-4 bg-zinc-950">
            Waiting for live operational events...
          </div>
        )}

        {events.map((event, idx) => {
          const formatted = formatDispatchEvent(event);

          if (!formatted) {
            return null;
          }

          return (
            <div
              key={idx}
              className={`border rounded-lg p-3 ${severityClass(formatted.severity)}`}
            >
              <div className="flex items-start justify-between gap-3">
                <div>
                  <div className="text-sm font-semibold capitalize">
                    {formatted.title}
                  </div>

                  <div className="text-xs opacity-80 mt-1">
                    {formatted.subtitle}
                  </div>
                </div>

                <div className="text-right">
                  <div className="text-[10px] uppercase tracking-wide opacity-70">
                    {formatted.category}
                  </div>

                  <div className="text-xs mt-1 opacity-80">
                    {formatted.time}
                  </div>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
